import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import _ from "lodash";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { FaFilter, FaUndo } from "react-icons/fa";
import CustomFilterInput from "../../../shared/CustomFilterInput";
import AppButton from "../../../shared/AppButton";

function PriceListFilter({ pageNo, limit, refetch, setLoading }) {
  const { t } = useTranslation();
  const [payers, setPayers] = useState([]);
  const navigate = useNavigate();

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    const day = String(date.getUTCDate()).padStart(2, "0");
    const hours = String(date.getUTCHours()).padStart(2, "0");
    const minutes = String(date.getUTCMinutes()).padStart(2, "0");
    const seconds = String(date.getUTCSeconds()).padStart(2, "0");
    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}Z`;
  };

  useEffect(() => {
    const payersData = JSON.parse(localStorage.getItem("payersData"));
    if (payersData && payersData.length > 0) {
      setPayers(payersData);
    } else {
      navigate("/dashboard");
    }
  }, []);

  const {
    values,
    handleChange,
    handleBlur,
    handleSubmit,
    setFieldValue,
    resetForm,
  } = useFormik({
    initialValues: {
      from_date: "",
      to_date: "",
      effective_date: "",
      payer_id: "",
      page: pageNo,
      limit: limit,
    },
    onSubmit: async (values) => {
      try {
        setLoading(true);
        await refetch({
          input: Object.keys(values).reduce((acc, key) => {
            const value = values[key];
            if (value !== "" && value !== null) {
              acc[key] = value;
            }
            return acc;
          }, {}),
        });
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <div className="w-full">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-x-2 gap-y-2 pb-2">
        <CustomFilterInput
          label={t("From Date")}
          name="from_date"
          value={values.from_date}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder={t("Start Date")}
          type="date"
        />
        <CustomFilterInput
          label={t("To Date")}
          name="to_date"
          value={values.to_date}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder={t("End Date")}
          type="date"
        />
        <CustomFilterInput
          label={t("Effective Date")}
          name="effective_date"
          value={values?.effective_date?.substring(0, 10)}
          onChange={(e) =>
            setFieldValue("effective_date", formatDate(e.target.value))
          }
          onBlur={handleBlur}
          placeholder={t("Effective Date")}
          type="date"
        />
        <CustomFilterInput
          label={t("Select Payer")}
          name="payer_id"
          value={values.payer_id}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder={t("Select Payer")}
          isSelect
          renderOptions={() =>
            payers.map((category) => (
              <optgroup
                key={category.id}
                label={
                  category?.name_en
                    ? `${category?.name_en} (${category?.license_id})`
                    : ""
                }
              >
                {category?.payers?.map((insurance, idx) => (
                  <option key={`${insurance.id}-${idx}`} value={insurance.id}>
                    {insurance?.name_en} ({insurance?.license_id})
                  </option>
                ))}
              </optgroup>
            ))
          }
        />
      </div>

      <div className="flex justify-end gap-2 pt-2 border-t">
        <AppButton
          label={t("Reset")}
          variant="reset"
          onClick={resetForm}
          startIcon={<FaUndo className="!text-[12px]" />}
          className="hover:!bg-slate-100"
        />
        <AppButton
          label={t("Apply Filter")}
          onClick={handleSubmit}
          startIcon={<FaFilter className="!text-[12px]" />}
        />
      </div>
    </div>
  );
}

export default PriceListFilter;
